// Money-amount text inputs (swap, stake, order prices) accept only digits and
// one decimal point: everything else, and every dot after the first, is
// dropped rather than the change refused, so a paste like "1.2.3" lands as
// "1.23". No decimals cap — precision belongs to the parser at the point of
// use (parseUnits throws on excess decimals; prices go through Number).
export function sanitizeDecimalInput(raw: string): string {
  const digitsAndDots = raw.replace(/[^0-9.]/g, '');
  const firstDot = digitsAndDots.indexOf('.');
  return digitsAndDots.replace(/\./g, (dot, offset: number) =>
    offset === firstDot ? dot : '',
  );
}
